import React, { useContext, useRef } from 'react';
import classes from './AccordionContent.module.scss';
import { MandatoryChildren } from '../../../../models/children-props';
import { AccordionContext } from '../AccordionProvider';
import classNames from 'classnames';
import { BreakpointsValuesEnum } from '../../../../constants/breakpoints-values';
import { useBreakpoints } from '../../../../hooks/useBreakpoints';
import { CSSTransition } from 'react-transition-group';
import { ErrorMessageSeverity } from '../../../../constants/form';

export type AccordionContentViewProps = MandatoryChildren & {
  //
  id: string;
  titleId: string;
  borderless?: boolean;
};

export const AccordionContentView = (props: AccordionContentViewProps): JSX.Element => {
  const { expanded, error } = useContext(AccordionContext);
  const breakpoint: keyof typeof BreakpointsValuesEnum = useBreakpoints();
  const cssRef = useRef<HTMLDivElement>(null);

  const hasError = error.flatMap(e => (e.severity === ErrorMessageSeverity.error ? e.id : [])).includes(props.titleId);
  const hasWarning = error
    .flatMap(e => (e.severity === ErrorMessageSeverity.warning ? e.id : []))
    .includes(props.titleId);

  const globalClasses = classNames(classes.AccordionContent, {
    [classes.AccordionContentDesktop]: breakpoint !== 'small' && breakpoint !== 'medium',
    [classes.AccordionContentDesktopBorderless]: breakpoint !== 'small' && breakpoint !== 'medium' && props.borderless,
    [classes.AccordionContentError]: hasError,
    [classes.AccordionContentDesktopError]: hasError && breakpoint !== 'small' && breakpoint !== 'medium',
    [classes.AccordionContentWarning]: !hasError && hasWarning,
    [classes.AccordionContentDesktopWarning]:
      !hasError && hasWarning && breakpoint !== 'small' && breakpoint !== 'medium'
  });

  const buffer =
    expanded === props.titleId ? (
      <div role={'region'} aria-labelledby={props.titleId} id={props.id} className={globalClasses} ref={cssRef}>
        {props.children}
      </div>
    ) : (
      <></>
    );

  return (
    <CSSTransition in={expanded === props.titleId} timeout={300} classNames={'scale-y'} nodeRef={cssRef}>
      {buffer}
    </CSSTransition>
  );
};
